module.exports = __webpack_public_path__ + "static/img_1050-5845028e2e0146c888457df3f7d62441.webp";